module.exports = __webpack_public_path__ + "media/images/icons/icon_volleyball-e8f43b80c41b025612ebb1a2b2b8f62f.png";